import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParametrosEnum } from 'src/app/shared/enums/parameters.enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { AutomaticRateService } from '../../services/automatic-rate.service';
import { BinanceService } from '../../services/binance.service';
import { ParameterService } from '../../services/parameter.service';
import { TransaccionService } from '../../services/transaccion.service';
import { SetValuesComponent } from '../admin-rate/manual-rate/set-values/set-values.component';
import {
  BinanceDepositService,
  DailyOperationsSummary,
  PendingWithdrawalsForApproval
} from '../../services/binance-deposit.service';
import {
  CompletedTotalsResponse,
  MontoPorMoneda,
  OperationsDashboardService,
  TotalesTipo,
} from '../../services/operations-dashboard.service';

@Component({
  selector: 'app-transactions-dashboard',
  templateUrl: './transactions-dashboard.component.html',
  styleUrls: ['./transactions-dashboard.component.sass'],
})
export class TransactionsDashboardComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject<void>();
  currentRates: any;
  currentValues: any;
  zelleSellValue: number = 0;
  zelleBuyValue: number = 0;
  usdt_clp_tax: number = 0;
  usdt_clp_tax_buy: number = 0;
  porCompZelle: number = 0;
  descVentaZelle: number = 0;
  foliosAguacate: any;
  foliosAguacateBoletas: number = 0;
  foliosAguacateFacturas: number = 0;
  foliosParra: any;
  foliosParraBoletas: number = 0;
  foliosParraFacturas: number = 0;
  foliosFabricaRosa: any;
  foliosFabricaRosaBoletas: number = 0;
  foliosFabricaRosaFacturas: number = 0;
  foliosAvocadoTech: any;
  foliosAvocadoTechBoletas: number = 0;
  foliosAvocadoTechFacturas: number = 0;
  rateValues: any = null;
  expandedSections: Set<string> = new Set();

  spotPrice: number = 0;
  pendingCount: any;
  completedCount: any;
  completedTotals?: CompletedTotalsResponse;
  yesterdayDate: Date = new Date();
  todayDate: Date = new Date();

  // Nuevas propiedades para operaciones USDT
  todayOperations?: DailyOperationsSummary;
  yesterdayOperations?: DailyOperationsSummary;
  pendingWithdrawals?: PendingWithdrawalsForApproval;
  loadingOperations: boolean = false;

  constructor(
    private binanceService: BinanceService,
    private dialog: MatDialog,
    private parameterService: ParameterService,
    private router: Router,
    private transactionService: TransaccionService,
    private spinner: SpinnerService,
    private cdr: ChangeDetectorRef,
    private automaticRateService: AutomaticRateService,
    private binanceDepositService: BinanceDepositService,
    private operationsDashboardService: OperationsDashboardService
  ) {}

  ngOnInit() {
    let ref = this.spinner.start();
    this.getCurrentRates();
    this.getCurrentValues();
    this.loadUsdtOperations();
    this.loadCompletedTotals();
    this.spinner.stop(ref);
    this.setupAutoRefresh();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getCurrentRates() {
    this.currentRates = await this.binanceService.getCurrentRates();
    this.yesterdayDate.setDate(this.todayDate.getDate() - 1);
  }

  async getCurrentValues() {
    this.currentValues = await this.binanceService.getConversionData();
    this.rateValues = await this.automaticRateService.getAutomaticRateSales();
    this.usdt_clp_tax = this.currentValues.tasaUsdtClp;
    this.usdt_clp_tax_buy = this.rateValues.tasa;
    await this.parameterService
      .getParameter(ParametrosEnum.FOLIOS_AGUACATE)
      .then((value) => {
        this.foliosAguacate = JSON.parse(value.valor);
      });
    this.foliosAguacateBoletas = this.foliosAguacate.BOLETAS;
    this.foliosAguacateFacturas = this.foliosAguacate.FACTURAS;
    await this.parameterService
      .getParameter(ParametrosEnum.FOLIOS_PARRA)
      .then((value) => {
        this.foliosParra = JSON.parse(value.valor);
      });
    this.foliosParraBoletas = this.foliosParra.BOLETAS;
    this.foliosParraFacturas = this.foliosParra.FACTURAS;
    await this.parameterService
      .getParameter(ParametrosEnum.FOLIOS_FABRICA_ROSA)
      .then((value) => {
        this.foliosFabricaRosa = JSON.parse(value.valor);
      });
    this.foliosFabricaRosaBoletas = this.foliosFabricaRosa.BOLETAS;
    this.foliosFabricaRosaFacturas = this.foliosFabricaRosa.FACTURAS;
    await this.parameterService
      .getParameter(ParametrosEnum.FOLIOS_AGUACATE_TECH)
      .then((value) => {
        this.foliosAvocadoTech = JSON.parse(value.valor);
      });
    this.foliosAvocadoTechBoletas = this.foliosAvocadoTech.BOLETAS;
    this.foliosAvocadoTechFacturas = this.foliosAvocadoTech.FACTURAS;
    await this.parameterService
      .getParameter(ParametrosEnum.DESCUENTO_COM_ZELLE)
      .then((value) => {
        this.descVentaZelle = value.valor;
      });
    await this.parameterService
      .getParameter(ParametrosEnum.PRECIO_SPOT)
      .then((value) => {
        this.spotPrice = value.valor;
      });
    await this.parameterService
      .getParameter(ParametrosEnum.PORC_VENTA_ZELLE)
      .then((value) => {
        this.porCompZelle = value.valor;
      });

    this.zelleSellValue = this.usdt_clp_tax * this.porCompZelle;
    this.zelleBuyValue = this.spotPrice - this.descVentaZelle;
    this.completedCount = await this.transactionService.getCompletedCount();
    this.pendingCount = await this.transactionService.getPendingCount();
  }
  private setupAutoRefresh() {
    interval(30000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getCurrentRates();
        this.getCurrentValues();
        this.loadUsdtOperations();
        this.loadCompletedTotals();
      });
  }

  /**
   * Carga los montos completados de hoy y ayer, desglosados por moneda.
   * Los contadores siguen viniendo de `completed-count` (wallet-back); esto
   * solo alimenta la linea de montos que va debajo de cada contador.
   */
  loadCompletedTotals() {
    this.operationsDashboardService.getCompletedTotals().subscribe({
      next: (data) => {
        this.completedTotals = data;
        this.cdr.detectChanges();
      },
      error: () => {},
    });
  }

  /**
   * Montos de un tipo de operacion, o null si todavia no hay nada que
   * mostrar. Devuelve el objeto tal cual llego del backend (referencia
   * estable) para no re-renderizar los *ngFor en cada ciclo de deteccion.
   * `dia` es 'currentDay' u 'previousDay'; `tipo` la clave del contador.
   */
  totalsFor(
    dia: 'currentDay' | 'previousDay',
    tipo: string,
  ): TotalesTipo | null {
    const totales: TotalesTipo | undefined = (this.completedTotals?.[dia] as any)?.[tipo];
    if (!totales) return null;
    return totales.destino.length || totales.origen.length ? totales : null;
  }

  /**
   * Formatea un monto con los decimales que corresponden a su moneda:
   * CLP y VES sin decimales, USDT/USD con dos.
   */
  formatMonto(monto: MontoPorMoneda): string {
    const decimales = monto.moneda === 'CLP' || monto.moneda === 'VES' ? 0 : 2;
    const valor = monto.total.toLocaleString('es-CL', {
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales,
    });
    return `${valor} ${monto.moneda}`;
  }

  /**
   * Carga las operaciones USDT de HOY, AYER y TOTALES
   */
  loadUsdtOperations() {
    this.loadingOperations = true;

    // Calcular fecha de ayer
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayStr = yesterday.toISOString().split('T')[0];

    // Cargar resumen de HOY
    this.binanceDepositService.getDailyOperationsSummary().subscribe({
      next: (data) => {
        this.todayOperations = data;
        this.cdr.detectChanges();
      },
      error: (error) => {
      }
    });

    // Cargar resumen de AYER
    this.binanceDepositService.getDailyOperationsSummary(yesterdayStr).subscribe({
      next: (data) => {
        this.yesterdayOperations = data;
        this.cdr.detectChanges();
      },
      error: (error) => {
      }
    });

    // Cargar retiros pendientes TOTALES
    this.binanceDepositService.getPendingWithdrawalsForApproval().subscribe({
      next: (data) => {
        this.pendingWithdrawals = data;
        this.loadingOperations = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.loadingOperations = false;
      }
    });
  }
  async actualizarTasa() {
    const data = {
      tasaBanesco: this.currentRates.valoresVES.valorBanesco,
      tasaProvincial: this.currentRates.valoresVES.valorBanesco,
      tasaVenezuela: this.currentRates.valoresVES.valorVenezuela,
      tasaMercantil: this.currentRates.valoresVES.valorMercantil,
      tasaCLP: this.currentRates.tasaCLP,
      porcentajeComision: this.currentRates.comision,
      fuente: 'MANUAL',
    };
    this.dialog
      .open(SetValuesComponent, { data })
      .afterClosed()
      .subscribe((res) => {
        if (res && res === true) {
          this.getCurrentRates();
          this.getCurrentValues();
        }
      });
  }

  /**
   * Abre el historial filtrado por lo que dice la tarjeta clickeada.
   *
   * Va con el criterio del tablero y no con el del historial completo:
   * `estados=ENVIADA` y `baseFecha=termino`. Si no, la lista muestra mas filas
   * que el numero de la tarjeta y parece que uno de los dos miente. El
   * historial avisa que esta en ese modo y ofrece soltarlo.
   *
   * El dia sale de `completedTotals`, que lo calcula el backend; el `Date` del
   * navegador es el plan B.
   */
  verOperaciones(dia: 'currentDay' | 'previousDay', tipo: string) {
    const fecha =
      this.completedTotals?.[dia]?.date ??
      this.aFechaLocal(dia === 'currentDay' ? this.todayDate : this.yesterdayDate);

    this.router.navigate(['/wallet/admin/operations-history'], {
      queryParams: {
        desde: fecha,
        hasta: fecha,
        grupos: tipo,
        estados: 'ENVIADA',
        baseFecha: 'termino',
        origen: 'tablero',
      },
    });
  }

  /** `Date` -> `'YYYY-MM-DD'` sin que el huso corra el dia. */
  private aFechaLocal(fecha: Date): string {
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${fecha.getFullYear()}-${mes}-${dia}`;
  }

  toggleSection(section: string) {
    if (this.expandedSections.has(section)) {
      this.expandedSections.delete(section);
    } else {
      this.expandedSections.add(section);
    }
  }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  formatDate(date: any) {
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];

    return `${day} ${month}`;
  }
}
